/* global G */
import { asyncPipeSpread, asyncPipeSpreadIf } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import session from 'app/_shared/session'

/**
 * Executes `action`.
 *
 * @param {string} action the action to execute
 * @returns {function(*): function(*, ...[*]): Promise<*[]>}
 */
const execAction = action => module => async (children, ...args) => {
  await module[G.ADAPTER][G.ROUTER].action(action)
  return args
}

/**
 * Person Create Action
 *
 * TODO: replace by using the {@link createWithAcl} handler with the create button.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  asyncPipeSpreadIf(() => session(module).isContext('req'))(
    execAction('newColleague')(module),
  ),
  asyncPipeSpreadIf(() => session(module).isContext('fse'))(
    execAction('create')(module),
  ),
  asyncPipeSpreadIf(() => !session(module).isContext('req', 'fse'))(
    execAction('newContact')(module),
  ),
)(find(component), ...args)
